import React from 'react'

interface DateIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const DateIcon: React.FC<DateIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Date icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M4.375 0C4.72 0 5 .28 5 .625v1.25h4.188V.625a.625.625 0 111.25 0v1.25h4.187V.625a.625.625 0 111.25 0v1.25h.313a3.437 3.437 0 013.437 3.438V7.75a.625.625 0 11-1.25 0V5.312c0-1.208-.98-2.187-2.188-2.187h-.312v1.25a.625.625 0 11-1.25 0v-1.25h-4.188v1.25a.625.625 0 11-1.25 0v-1.25H5v1.25a.625.625 0 11-1.25 0v-1.25h-.313c-1.208 0-2.187.98-2.187 2.188v10.875c0 1.208.98 2.187 2.188 2.187h4.5a.625.625 0 110 1.25h-4.5A3.437 3.437 0 010 16.187V5.313a3.438 3.438 0 013.438-3.437h.312V.625C3.75.28 4.03 0 4.375 0zm7.75 17.125a5 5 0 1110 0 5 5 0 01-10 0zm5-6.25a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm0 3.75c.345 0 .625.28.625.625v1.25H19a.625.625 0 110 1.25h-1.875a.625.625 0 01-.625-.625V15.25c0-.345.28-.625.625-.625zM4.287 8.512a.85.85 0 100-1.7.85.85 0 000 1.7zm0 3.7a.85.85 0 100-1.7.85.85 0 000 1.7zm.85 2.85a.85.85 0 11-1.7 0 .85.85 0 011.7 0zm3.7-7.4a.85.85 0 11-1.7 0 .85.85 0 011.7 0zm0 3.7a.85.85 0 11-1.7 0 .85.85 0 011.7 0zm-.85 4.55a.85.85 0 100-1.7.85.85 0 000 1.7zm4.55-8.25a.85.85 0 11-1.7 0 .85.85 0 011.7 0zm3.7 0a.85.85 0 11-1.7 0 .85.85 0 011.7 0z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default DateIcon
